<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="max-width: 600px;">
  <div class="search-wrapper mat-elevation-z1" style="flex: 1;">
    <div class="search" fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="isLoading"><mat-spinner style="float:right;" diameter="25"></mat-spinner></div>
      <mat-icon [ngClass]="{'animate': true}">search</mat-icon>
      <input
        #searchInput="matAutocompleteTrigger"
        style="flex: 1; min-width: 0;"
        type="text"
        [placeholder]="translate.instant('FORM_FIELD.SEARCH')"
        [formControl]="myControl"
        [matAutocomplete]="auto"
      >
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onSelectionChanged($event)"
      >
        <mat-option *ngFor="let option of optionList" [value]="option" [disabled]="edit">
          <span *ngIf="option?.name && option?.surname">{{ option.name + ' ' + option.surname }} <b>{{ option.type }}</b></span>
          <span *ngIf="option?.name && !option?.surname">{{ option.name }} <b>{{ option.type }}</b></span>
          <span *ngIf="!option?.name && option?.surname">{{ option.surname }} <b>{{ option.type }}</b></span>
          <span *ngIf="!option?.name && !option?.surname">{{ option.id }}</span>
        </mat-option>
        <div *ngIf="noResults">
          <mat-option disabled>
            <span><b>{{ 'LABEL.NoSearchResults' | translate }}</b></span>
          </mat-option>
        </div>
      </mat-autocomplete>
      <button *ngIf="myControl.value" style="background-color:transparent; flex-shrink: 0;" matTooltip="Clear" type="button" class="btn" (click)="clear()">
        <mat-icon class="material-icons" style="color:#293683;">clear</mat-icon>
      </button>
    </div>
  </div>
  <ng-container *ngIf="showAdvancedSearch">
    <button mat-raised-button type="button"
      style="flex-shrink: 0; background-color: #3f51b5; color: white; font-size: 11px; padding: 0 8px; min-width: 0; line-height: 36px; height: 36px;"
      (click)="openAdvancedSearchDialog()"
      matTooltip="Ricerca Avanzata"
      [matBadge]="activeFiltersCount > 0 ? activeFiltersCount : null"
      matBadgeColor="warn"
      matBadgeSize="small">
      <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; margin-right: 4px;">manage_search</mat-icon>
      Ricerca A.
    </button>
    <button *ngIf="activeFiltersCount > 0" mat-icon-button color="warn" type="button" style="flex-shrink: 0;"
      (click)="resetDialogFilters()"
      [matTooltip]="'LABEL.RESET_FILTERS_BTN' | translate">
      <mat-icon>filter_alt_off</mat-icon>
    </button>
  </ng-container>
</div>
<p style="padding-left: 3%; padding-bottom: 1.5%;">{{ 'ALERT.MESS1' | translate }}</p>
